import { defineStore } from 'pinia';
import router from '../router'
import { Sesion } from '../Api/API_Concentrador'
import axios from '../axios';
import { jwtDecode } from 'jwt-decode';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        // initialize state from local storage to enable user to stay logged in
        usuario: localStorage.getItem('usuario') ? JSON.parse(localStorage.getItem('usuario')) : JSON.parse(sessionStorage.getItem('usuario')),
        access_token: localStorage.getItem('access_token') ? localStorage.getItem('access_token') : sessionStorage.getItem('access_token'),
        refresh_token: localStorage.getItem('refresh_token') ? localStorage.getItem('refresh_token') : sessionStorage.getItem('refresh_token'),
        rememberMe: localStorage.getItem('rememberMe') ? localStorage.getItem('rememberMe') : sessionStorage.getItem('rememberMe'),
    }),
    actions: {
        async login(username, password, rememberMe) {
            try {
                const res = await Sesion.iniciarSesion(username, password)
                const data = res.data;
                const profile = data.user;

                // update pinia state
                this.usuario = {
                    username: profile?.username ?? profile?.userName ?? data.userName ?? username,
                    id: profile?.id ?? data.id,
                    email: profile?.email ?? null
                }

                this.access_token = data.token;
                this.refresh_token = data.refreshToken;

                this.rememberMe = rememberMe;

                axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`

                let store = rememberMe ? localStorage : sessionStorage;

                store.setItem('rememberMe', rememberMe);
                store.setItem('usuario', JSON.stringify(this.usuario));
                store.setItem('access_token', this.access_token);

                const { exp: exp_access } = jwtDecode(data.token);
                const { exp: exp_refresh } = jwtDecode(data.refreshToken);

                store.setItem('access_token_expiration', exp_access * 1000); //exp viene en segundos
                store.setItem('refresh_token', this.refresh_token);
                store.setItem('refresh_token_expiration', exp_refresh * 1000); //exp viene en segundos


                //Token de Notificaciones
                // store.setItem('token_notificaciones', res.token_notificaciones);// 8 dias

                // redirect to previous url or default to home page
                router.push(this.returnUrl || '/productos?page=1&step=5');
            } catch (error) {
                throw error;
                //console.error(error);
            }
        },
        refreshToken(token) {
            let store = localStorage.getItem("access_token") ? localStorage : sessionStorage;
            store.setItem("access_token", token);
            const { exp } = jwtDecode(token);
            store.setItem("access_token_expiration", exp * 1000); //exp viene en segundos
            this.access_token = token;
        },
        async ensureProfile() {
            if (!this.usuario || this.usuario.username || this.usuario.userName || this.usuario.nombre || !this.access_token)
                return;

            try {
                const profile = await Sesion.obtenerPerfil();
                this.usuario = {
                    id: profile.id,
                    username: profile.username,
                    email: profile.email
                };
                const store = localStorage.getItem('usuario') ? localStorage : sessionStorage;
                store.setItem('usuario', JSON.stringify(this.usuario));
            } catch {
                // Si el servidor no está disponible, la sesión puede seguir activa.
            }
        },
        logout() {
            this.usuario = null;
            this.access_token = null;
            this.refresh_token = null;
            this.rememberMe = null;
            const authKeys = [
                'rememberMe', 'usuario', 'access_token', 'access_token_expiration',
                'refresh_token', 'refresh_token_expiration', 'token_notificaciones'
            ];
            for (const key of authKeys) {
                localStorage.removeItem(key);
                sessionStorage.removeItem(key);
            }
            router.push('/login');
        }
    }
});

export default useAuthStore;
